import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/login';
import MainPage from './components/mainpage';
import AdminPage from './components/adminpage'; // asegúrate de tener este componente
import { InfraccionesProvider } from './context/InfraccionesContext';
import { logout } from './components/autenticacion';
import { getStoredUser } from './utils/session';

// Ruta protegida para administradores
function AdminRoute({ children }) {
  const user = JSON.parse(localStorage.getItem('user'));

  if (!user || (user.rol !== 'admin' && user.rol !== 'director')) {
    return <Navigate to="/mainpage" />;
  }

  return children;
}

export default function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = getStoredUser();
    setSession(user);
    setLoading(false);
  }, []);

  const handleLogout = async () => {
    await logout();
    setSession(null);
  };

  if (loading) return <p>Cargando...</p>;

  console.log("Renderizando con sesion:", session);

  return (
    <InfraccionesProvider>
      <Router>
        <Routes>
          {session ? (
            <>
              <Route path="/mainpage" element={<MainPage onLogout={handleLogout} />} />

              {/* Ruta protegida para admin */}
              <Route
                path="/adminpage"
                element={
                  <AdminRoute>
                    <AdminPage />
                  </AdminRoute>
                }
              />

              <Route path="*" element={<Navigate to="/mainpage" />} />
            </>
          ) : (
            <>
              <Route path="/login" element={<Login onLogin={setSession} />} />
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          )}
        </Routes>
      </Router>
    </InfraccionesProvider>
  );
}
